// extracted by mini-css-extract-plugin
module.exports = {"modalQuestion":"Styles_modalQuestion__2Fova","modal-header":"Styles_modal-header__2zgdo","modalQuestion_header":"Styles_modalQuestion_header__2x9Sn","close":"Styles_close__2-ywe"};